import React, { useEffect, useRef, useState } from 'react';
import { Icon } from './ds';
import { FilterDropdown } from './FilterDropdown.jsx';

export const CONTACT_FIELD_MAX = 100;

export function LeadStripTextField({ icon, label, value, onCommit }) {
    const [draft, setDraft] = useState(value ?? '');
    const skipCommitRef = useRef(false);
    useEffect(() => { setDraft(value ?? ''); }, [value]);

    const commit = () => {
        if (skipCommitRef.current) { skipCommitRef.current = false; return; }
        const next = draft.trim();
        if (next === (value ?? '')) { setDraft(value ?? ''); return; }
        onCommit(next);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            event.currentTarget.blur();
        } else if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            skipCommitRef.current = true;
            setDraft(value ?? '');
            event.currentTarget.blur();
        }
    };

    return (
        <span className='oc-lead-card__strip-field'>
            <Icon name={icon} size='sm' />
            <span className='oc-lead-card__strip-label'>{label}</span>
            <input
                type='text'
                className='oc-lead-card__strip-input'
                value={draft}
                maxLength={CONTACT_FIELD_MAX}
                placeholder='—'
                aria-label={label}
                onChange={(event) => setDraft(event.target.value)}
                onBlur={commit}
                onKeyDown={handleKeyDown}
            />
        </span>
    );
}

export function LeadStripOptionField({ icon, label, options, value, onPick }) {
    const stored = typeof value === 'string' ? value : '';
    const items = [{ value: '', label: '—' }, ...options.map((o) => ({ value: o, label: o }))];
    return (
        <span className='oc-lead-card__strip-field'>
            <Icon name={icon} size='sm' />
            <span className='oc-lead-card__strip-label'>{label}</span>
            <FilterDropdown
                value={stored}
                onChange={(next) => { if (next !== stored) onPick(next); }}
                placeholder='—'
                currentLabel={stored || undefined}
                className='oc-lead-card__strip-dd'
                triggerClassName='oc-lead-card__strip-trigger'
                options={items}
            />
        </span>
    );
}

export default LeadStripTextField;
